import { TableFormItem } from "@/containers/ProjectTemplate/styled";
import { Checkbox, Row } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";

interface IProps {
  checked: boolean;
  disabled?: boolean;
  onChange(checked: boolean): void;
}

export const TableCheckbox = ({
  checked,
  disabled = false,
  onChange,
}: IProps) => {
  const handleChange = (changeEvent: CheckboxChangeEvent): void => {
    onChange(changeEvent.target.checked);
  };

  return (
    <Row justify="space-around">
      <TableFormItem>
        <Checkbox
          data-test-id="table-checkbox"
          checked={checked}
          onChange={(data): void => handleChange(data)}
          disabled={disabled}
        />
      </TableFormItem>
    </Row>
  );
};
